module.exports = __webpack_public_path__ + "img/clickandbuy.7c6522ec.png";